<template>
    <PageContainer :isLoading="isLoading" :error="error">
        <KnownMeasureDetail :known_measure_id="id"/>
    </PageContainer>
</template>

<script>
import KnownMeasureDetail from './KnownMeasureDetail';

import { fetchUser } from '@/mixins';

export default {
    mixins: [fetchUser],
    props: ['id'],

    components: { KnownMeasureDetail },
};
</script>
